import { Component, Injectable, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { UserService } from '../../../../../common/services/User.service';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from '../../../../../common/services/Group.service';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { OrganizeService } from '../../../../../common/services/Organize.service';
import { SocketService } from '../../../../../common/services/Socket.service';
import { UtilityService } from 'app/common/services/Utility.service';

@Component({
  moduleId: module.id,
  selector: 'user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.css'],
  providers: [UserService, GroupService, BsModalService, OrganizeService, UtilityService],
})
@Injectable()
export class UserComponent implements OnInit {
  public user: any = {};
  public no_image = 'assets/images/contact.png';
  public group_image = 'assets/images/group.png';
  public tab = 'user';
  public page_size = 10;
  public currentPage = 1;
  public message: { class: string; content: string } = null;
  totalItem: any = 0;
  totalPage: any = 0;
  modalRef: any;

  public list: any = [];
  public total = 0;
  public modelFilter: any = {};
  public model: any = {};

  public modalRef2: any;
  public id_delete: any;
  public limited: number;
  public editGroup: any = {};
  public is_load_data = false;
  public allGroup: any = [];

  @ViewChild('templateUser') templateUser: ElementRef;
  @ViewChild('templateGroup') templateGroup: ElementRef;
  @ViewChild('templateOrganize') templateOrganize: ElementRef;

  constructor(
    private userService: UserService,
    private groupService: GroupService,
    private organizeService: OrganizeService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private socketService: SocketService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {
    this.getGroup();
    this.loadData();
  }

  loadData(request: any = {}) {
    switch (this.tab) {
      case 'user': {
        this.loadUser(request);
        break;
      }
      case 'group': {
        this.loadGroup(request);
        break;
      }
      case 'organize': {
        this.loadOrganize(request);
        break;
      }
      default:
        break;
    }
  }

  loadUser(request: any = {}, sort: any = {}) {
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.userService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.list = res.data.list;
        this.total = res.data.total;
        this.limited = res.data.limited;

        const pageString = (this.total / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
      }
    });
  }

  openUser(user) {
    this.socketService.opentab(user, 'user', 'edit');
  }

  openOrganize(organize) {
    this.socketService.opentab(organize, 'organize', 'edit');
  }
  loadGroup(request: any = {}, sort: any = {}) {
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.groupService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.list = res.data.list;
        this.total = res.data.total;
        const pageString = (this.total / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
      }
    });
  }

  loadOrganize(request: any = {}, sort: any = {}) {
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.organizeService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.list = res.data.list;
        this.total = res.data.total;

        const pageString = (this.total / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
      }
    });
  }

  openModal() {
    this.model = {};

    this.userService.generateAgentId().subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.model.agent_id = res.data.agent_id;
      }
    });
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    switch (this.tab) {
      case 'user': {
        this.modalRef = this.modalService.show(this.templateUser, config);
        break;
      }
      case 'group': {
        this.modalRef = this.modalService.show(this.templateGroup, config);
        break;
      }
      case 'organize': {
        this.modalRef = this.modalService.show(this.templateOrganize, config);
        break;
      }
      default:
        break;
    }
  }

  addUser() {
    this.userService.create(this.model).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Lưu không thành công',
            };
            this.toastr.error('Lưu không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });

            setTimeout(() => this.loadData(), 3000);
            this.modalRef.hide();
          }
        }
      },
      error => {
        // this.toastr.error(error.message, 'Lưu không thành công', {
        //     timeOut: 4000,
        //     positionClass: 'toast-bottom-right'
        // });
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        setTimeout(() => (this.message = null), 3000);
      }
    );
  }

  addGroup() {
    this.groupService.create(this.model).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Lưu không thành công',
            };
            this.toastr.error('Lưu không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });

            this.loadData();
            this.modalRef.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        setTimeout(() => (this.message = null), 3000);
      }
    );
  }

  addOrganize() {
    if (this.model.name) {
      this.model.name = this.model.name.trim();
    }
    this.organizeService.create(this.model).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Lưu không thành công',
            };
            this.toastr.error('Lưu không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });

            this.loadData();
            this.modalRef.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        setTimeout(() => (this.message = null), 3000);
      }
    );
  }

  search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      if (this.tab == 'user') {
        const isnum = UtilityService.isValidPhoneNumber(this.modelFilter.keyword.trim());
        if (!isnum) {
          const filters = [];
          this.modelFilter.keyword
            .replace(/\s+/g, ' ')
            .trim()
            .split(' ')
            .forEach(element => {
              filters.push({
                key: 'name',
                condition: 'like',
                value: element.toLowerCase(),
              });
            });

          this.loadData({ filters: JSON.stringify(filters) });
        } else {
          const filters = [];
          filters.push({
            key: 'phone',
            condition: '=',
            value: this.modelFilter.keyword.trim(),
          });
          this.loadData({ filters: JSON.stringify(filters) });
        }
      } else {
        this.loadData({ name: this.modelFilter.keyword.trim() });
      }
    } else {
      this.loadData();
    }
  }

  changeTab(tab) {
    this.tab = tab;
    this.currentPage = 1;
    this.totalItem = 0;
    this.totalPage = 0;
    this.list = [];
    this.total = 0;
    this.modelFilter = {};
    this.loadData();
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    if (this.tab == 'group') {
      this.groupService._delete(this.id_delete).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.toastr.error('Xóa không thành công', error.message, {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.toastr.success('Xóa thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadData();
              // this.modalRef2.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
          this.toastr.error('Xóa không thành công', error.message, {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.loadData();
          // this.modalRef2.hide();
        }
      );
    } else if (this.tab == 'organize') {
      this.organizeService._delete(this.id_delete).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.toastr.error('Xóa không thành công', error.message, {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.toastr.success('Xóa thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadData();
              // this.modalRef2.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
          this.toastr.error('Xóa không thành công', error.message, {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.loadData();
        }
      );
    }
  }

  getGroup() {
    this.is_load_data = true;
    this.groupService.allGroup({ target: 'user' }).subscribe(res => {
      const groupList = [{ id: '', text: '' }];
      res.data.forEach((c: any) => {
        groupList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allGroup = groupList;
      this.is_load_data = false;
    });
  }

  changedGroup($event) {
    if (!this.is_load_data) {
      this.model['group_id'] = $event.value;
    }
  }

  openUpdateGroup(template: TemplateRef<any>, group) {
    this.editGroup.id = group.id;
    this.editGroup.name = group.name;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef2 = this.modalService.show(template, config);
  }

  updateGroup() {
    this.groupService.update(this.editGroup).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Lưu không thành công',
            };
            this.toastr.error('Lưu không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });

            this.loadData();
            this.modalRef2.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        setTimeout(() => (this.message = null), 3000);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/user/user.component.ts